/**
 * Collection of icons that are part of the element components. (directly related to the general UI components)
 *
 * REMEMBER: Icon file paths/filenames are case sensitive once deployed! So make sure the casing matches exactly!
 *
 */
export const ElementIcons = {
  // Radio element
  Radio_Normal: { fileName: '/images/elements/radio/radio-normal.svg', xOffset: 0, yOffset: 0 },
  Radio_Selected: { fileName: '/images/elements/radio/radio-selected.svg', xOffset: 0, yOffset: 0 },
  Radio_Hover: { fileName: '/images/elements/radio/radio-hover.svg', xOffset: 0, yOffset: 0 },
  Radio_Disabled: { fileName: '/images/elements/radio/radio-disabled.svg', xOffset: 0, yOffset: 0 },
  Radio_SelectedDisabled: { fileName: '/images/elements/radio/radio-selected-disabled.svg', xOffset: 0, yOffset: 0 },

  // Check element
  Check_Normal: { fileName: '/images/elements/check/checkbox-normal.svg', xOffset: 0, yOffset: 0 },
  Check_Selected: { fileName: '/images/elements/check/checkbox-selected.svg', xOffset: 0, yOffset: 0 },
  Check_Selected_Check: { fileName: '/images/elements/check/icon-checked.svg', xOffset: 6, yOffset: 0, width: 12, height: 12 },
  Check_Hover: { fileName: '/images/elements/check/checkbox-hover.svg', xOffset: 0, yOffset: 0 },
  Check_Disabled: { fileName: '/images/elements/check/checkbox-disabled.svg', xOffset: 0, yOffset: 0 },
  Check_SelectedDisabled: { fileName: '/images/elements/check/checkbox-selected-disabled.svg', xOffset: 0, yOffset: 0 },
  Check_IndeterminateSelected: { fileName: '/images/elements/check/checkbox-indeterminate-selected.svg', xOffset: 0, yOffset: 0 },
  Check_IndeterminateDisabled: { fileName: '/images/elements/check/checkbox-indeterminate-disabled.svg', xOffset: 0, yOffset: 0 },

  // Switch element
  Switch_Off: { fileName: '/images/elements/switch/switch-off.svg' },
  Switch_On: { fileName: '/images/elements/switch/switch-on.svg' },

  // Text element
  Text_Success: { fileName: '/images/elements/text/text-success.svg' },

  // ----------------------------------------------------
  // The icons below here should be moved to other Icon object. This object should contain icons only directly used by elements.
  // Inspection check & cancel
  Inspection_Check: { fileName: '/images/icons/Green_chekmark.png', width: 16, height: 16, yOffset: 4 },
  Inspection_Cancel: { fileName: '/images/icons/Red_marking.png', width: 16, height: 16, yOffset: 4 },

  // Misc
  Indent: { fileName: '/images/svgs/Indent.svg' },

  Hide: { fileName: '/images/svgs/eye-hide.svg' },
  Show: { fileName: '/images/svgs/eye-show.svg' },
  Edit: { fileName: '/images/icons/edit_16.png', width: 16, height: 16 },
  Info: { fileName: '/images/elements/misc/Info.svg' },
  Chevron_Right: { fileName: '/images/elements/misc/Chevron-Right.svg' },
  Drag_Icon: { fileName: '/images/svgs/action-swipe-dot.svg' },
  Log_Icon: { fileName: '/images/svgs/log.svg' },
  Delete: { fileName: '/images/icons/Delete.png' },
  Infinity: { fileName: '/images/svgs/infinity.svg' },
  Info_Circle: { fileName: '/images/svgs/Cirkle_info-black.svg' },
  Customer: { fileName: '/images/icons/Customer_16.png' },
  Files: { fileName: '/images/svgs/workscreen/add-files.svg' },
  Close: { fileName: '/images/icons/close_24-Black.png' },
  Add_Circle: { fileName: '/images/icons/circle_plus22.png' },
  Add_Circle_Black: { fileName: '/images/icons/circle_plus22-black.png' },
  Plus_White: { fileName: '/images/icons/Plus-White.png' },
  Minus_White: { fileName: '/images/icons/Minus-White_16px.png' },
  Arrow_Left_White: { fileName: '/images/svgs/Arrow-left-white.svg' },
  Arrow_Right_White: { fileName: '/images/svgs/Arrow-right-white.svg' },
  Arrow_Left_Gray: { fileName: '/images/svgs/ordrer/arrow-left-gray.svg' },
  Arrow_Left_Lightgray: { fileName: '/images/svgs/ordrer/arrow-left-lightgray.svg' },
  Arrow_Right_Gray: { fileName: '/images/svgs/ordrer/arrow-right-gray.svg' },
  Arrow_Right_Lightgray: { fileName: '/images/svgs/ordrer/arrow-right-lightgray.svg' },
  Menu_Dots_Black: { fileName: '/images/svgs/menuicons/Menu_dots-Black.svg' },
  Go_Back_Black: { fileName: '/images/svgs/go-back.svg' },

  // Search state
  Include: { fileName: '/images/icons/Include_in_search22.png' },
  Empty: { fileName: '/images/icons/Empty_22.png' },
  Filled_In: { fileName: '/images/icons/Filled_in_22.png' },
  Exclude: { fileName: '/images/icons/Exclude_from_search_22.png' },

  // Price calculation
  Workflow: { fileName: '/images/svgs/pricecalculation/workflow.svg' },
  Spare_Parts: { fileName: '/images/svgs/pricecalculation/spare-parts.svg' },

  Warning: { fileName: '/images/svgs/capacitymanagement/warning-red.svg' }
}

export const GeneralIcons = {
  Apromas_Logo: { fileName: '/images/svgs/apromas-logo.svg' },
  Qars_Logo: { fileName: '/images/Q-grey.svg' },
  BadgeOverlay_Circle_White: { fileName: '/images/svgs/taksering/badge-overlay-circle-white.svg' },
  Info_Circle_Grey: { fileName: '/images/icons/Cirkle_info-grey25x25px.png' },
  Print: { fileName: '/images/svgs/Print.svg' },
  Arrow_Left_Blue: { fileName: '/images/svgs/arrow-left-blue.svg' },
  Arrow_Right_Blue: { fileName: '/images/svgs/arrow-right-blue.svg' }
}

export const FileIcons = {
  Download_Black: { fileName: '/images/svgs/download.svg' }
}

// Localization - put flags and related symbols here.
export const Localization = {
  EU_Star: { fileName: '/images/svgs/localization/eu-stars.svg' }
}

// TODO: Merge StepIcons into FilterIcons
export const FilterIcons = {
  Magnifier_Black: { fileName: '/images/svgs/Search-black.svg' }
}

export const StepIcons = {
  Bodyshop_Coating: { fileName: '/images/svgs/bodyshop-steps/Coating-blue.svg' },
  Bodyshop_Bodywork: { fileName: '/images/svgs/bodyshop-steps/bodywork-2-blue.svg' }
}

export const CarIcons = {
  Small: { fileName: '/images/icons/car/car-icon_S.png' },
  Medium: { fileName: '/images/icons/car/car-icon_M.png' },
  Large: { fileName: '/images/icons/car/car-icon_L.png' }
}

// Find better name for this icon-set (stuff related to employee vs. order type actions).
export const AssignmentIcons = {
  Assign_Employee_Black: { fileName: '/images/icons/Assign-Black.png' },
  Warning: { fileName: '/images/svgs/capacitymanagement/warning-red.svg' }
}

/**
 * Icons for commonly used buttons. (don't add buttons here for specialized purposes)
 */
export const ButtonIcons = {
  Add_Plus_16: { fileName: '/images/elements/buttons/add-plus-black-16.svg', xOffset: -1, yOffset: -1 },
  Add_Plus_Link_16: { fileName: '/images/elements/buttons/add-plus-blue-16.svg', xOffset: -1, yOffset: -1 },
  Remove_Minus_Alert_16: { fileName: '/images/elements/buttons/remove-minus-red-16.svg', xOffset: -1, yOffset: -1 },
  Remove_Bin_Alert_16: { fileName: '/images/elements/buttons/remove-bin-red-16.svg', xOffset: -1, yOffset: -1 },
  Arrow_Link_16: { fileName: '/images/elements/buttons/arrow-blue-16.svg', xOffset: -1, yOffset: -1 },

  Add_Plus_20: { fileName: '/images/elements/buttons/add-plus-black-20.svg', xOffset: -1, yOffset: -1 },
  Add_Plus_Link_20: { fileName: '/images/elements/buttons/add-plus-blue-20.svg', xOffset: -1, yOffset: -1 },
  Remove_Minus_Alert_20: { fileName: '/images/elements/buttons/remove-minus-red-20.svg', xOffset: -1, yOffset: -1 },
  Remove_Bin_Alert_20: { fileName: '/images/elements/buttons/remove-bin-red-20.svg', xOffset: -1, yOffset: -1 },
  Arrow_Link_20: { fileName: '/images/elements/buttons/arrow-blue-20.svg', xOffset: -1, yOffset: -1 },

  Add_Plus_24: { fileName: '/images/elements/buttons/add-plus-black-24.svg', xOffset: -1, yOffset: -1 },
  Add_Plus_Link_24: { fileName: '/images/elements/buttons/add-plus-blue-24.svg', xOffset: -1, yOffset: -1 },
  Remove_Minus_Alert_24: { fileName: '/images/elements/buttons/remove-minus-red-24.svg', xOffset: -1, yOffset: -1 },
  Remove_Bin_Alert_24: { fileName: '/images/elements/buttons/remove-bin-red-24.svg', xOffset: -1, yOffset: -1 },
  Arrow_Link_24: { fileName: '/images/elements/buttons/arrow-blue-24.svg', xOffset: -1, yOffset: -1 }
}

export const NumPadIcons = {
  Delete_Red: { fileName: '/images/elements/buttons/delete-red.svg' }
}

/**
 * Icons representing order steps
 */
export const OrderStepIcons = {
  Quality_Check_New: { fileName: '/images/icons/step_icons/Neworder-Black_16px.png', height: 16 },
  Quality_Check_Pretreatment: { fileName: '/images/icons/step_icons/Pretretment-Black_16px.png', height: 16 },
  Quality_Check_Filler: { fileName: '/images/icons/step_icons/Filer-Black_16px.png', height: 16 },
  Quality_Check_Sanding: { fileName: '/images/icons/step_icons/Sanding-Black_16px.png', height: 16 },
  Quality_Check_Coating: { fileName: '/images/icons/step_icons/coating-Black_16px.png', height: 16 },
  Quality_Check_Preparing: { fileName: '/images/icons/step_icons/Preparing-black.png', height: 16 },
  Quality_Check_Handover: { fileName: '/images/icons/step_icons/Handsover-Black_16px.png', height: 16 }
}

export const QualityCheckIcons = {
  Quality_Check_New: { fileName: '/images/svgs/workscreen/neworder.svg' },
  Quality_Check_Disassembly: { fileName: '/images/svgs/workscreen/demount.svg' },
  Quality_Check_Repair: { fileName: '/images/svgs/workscreen/reparation.svg' },
  Quality_Check_Pretreatment: { fileName: '/images/svgs/workscreen/pretreatment.svg' },
  Quality_Check_Filler: { fileName: '/images/svgs/workscreen/filler.svg' },
  Quality_Check_Sanding: { fileName: '/images/svgs/workscreen/sanding.svg' },
  Quality_Check_Coating: { fileName: '/images/svgs/workscreen/coating.svg' },
  Quality_Check_Preparing: { fileName: '/images/svgs/workscreen/preparing.svg' },
  Quality_Check_Assembly: { fileName: '/images/svgs/workscreen/mount.svg' },
  Quality_Check_Preparing_Body: { fileName: '/images/svgs/workscreen/clean.svg' },
  Quality_Check_Handover: { fileName: '/images/svgs/workscreen/delivered.svg' },
  Quality_Check_Finished: { fileName: '/images/svgs/inspection/price.svg' }
}

export const OrderTypeIcons = {
  Insurance_Black: { fileName: '/images/svgs/ordrer/Insurance-black.svg' },
  Insurance_White: { fileName: '/images/svgs/ordrer/Insurance-white.svg' },
  Salescar_Black: { fileName: '/images/svgs/ordrer/Salescar-black.svg' },
  Salescar_White: { fileName: '/images/svgs/ordrer/Salescar-white.svg' },
  Garanteed_Black: { fileName: '/images/svgs/ordrer/Garanteed-black.svg' },
  Garanteed_White: { fileName: '/images/svgs/ordrer/Garanteed-white.svg' },
  Complaint_Black: { fileName: '/images/svgs/ordrer/Complaint-black.svg' },
  Complaint_White: { fileName: '/images/svgs/ordrer/Complaint-white.svg' },
  Private_Black: { fileName: '/images/svgs/ordrer/Private_c-black.svg' },
  Private_White: { fileName: '/images/svgs/ordrer/Private_c-white.svg' },
  Other_Black: { fileName: '/images/svgs/ordrer/Other-black.svg' },
  Other_White: { fileName: '/images/svgs/ordrer/Other-white.svg' }
}

export const TransportTypeIcons = {
  Can_Drive: { fileName: '/images/icons/can_drive16.png' },
  Loose_Part: { fileName: '/images/svgs/transport/loose part-black.svg' },
  Transport: { fileName: '/images/icons/transport16.png' }
}

export const InvoiceIcons = {
  Sent_To_Invoice: { fileName: '/images/svgs/invoice/posted-not-billed.svg', width: 24, height: 24 },
  Marked_As_Invoice: { fileName: '/images/svgs/invoice/billed-not-posted.svg', width: 24, height: 24 },
  Sent_And_Marked: { fileName: '/images/svgs/invoice/Payment-ok-VS.svg', width: 24, height: 24 },
  Invoice_Reset_Approved: { fileName: '/images/svgs/invoice/approved-for-invoicing_reset.svg' },
  Invoice_Reset: { fileName: '/images/svgs/invoice/reset-invoising.svg' },
  Total_Price: { fileName: '/images/svgs/invoice/Total_price.svg' },
  Ready_Invoice: { fileName: '/images/svgs/invoice/ready-for-invoice.svg' },
  Invoiced: { fileName: '/images/svgs/invoice/Payment-ok.svg' }

}

export const OrderDepartmentIcons = {
  Body: { fileName: '/images/svgs/workscreen/bodywork.svg' },
  Paint: { fileName: '/images/svgs/workscreen/coating.svg' }
}

export const HeaderIcons = {
  Estimation_Request_White: { fileName: '/images/svgs/header-icons/additional-support-added-all-white.svg' },
  Payment_Notification_White: { fileName: '/images/svgs/header-icons/Payment-notification-all-white.svg' },
  Forsi_Not_Active_White: { fileName: '/images/svgs/header-icons/FORSI-not-active-all-white.svg' },
  Update_With_Circle_White: { fileName: '/images/svgs/header-icons/Update-VS-white-circle.svg' },
  Message_With_Circle_White: { fileName: '/images/svgs/header-icons/Message-circle-all-white.svg' },
  Task_With_Circle_White: { fileName: '/images/svgs/header-icons/Task-circle-white.svg' },
  Update_White: { fileName: '/images/svgs/header-icons/Update-VS-white.svg' },
  Order_With_Circle_White: { fileName: '/images/svgs/header-icons/my-orders-white.svg' },
  BookingRequest_White: { fileName: '/images/svgs/header-icons/car-owner-booking-request-white.svg' }
}

export const OrderAssessmentIcons = {
  Extent: { fileName: '/images/svgs/taksering/Charging-Black.svg' },
  Invoice_Awaiting: { fileName: '/images/svgs/invoicelog/price-change-sent_black.svg' },
  Invoice_Approved_Rejected: { fileName: '/images/svgs/invoicelog/price-change-approved_black.svg' },
  Main_Report: { fileName: '/images/svgs/invoicelog/main-report-received.svg' },
  Main_Report_White: { fileName: '/images/svgs/invoicelog/main-report-received-white.svg' },

  Charged_Later_Recieved: { fileName: '/images/svgs/taksering/charged-later-recieved.svg' },
  Charged_Later_Sent: { fileName: '/images/svgs/taksering/charged-later-sent.svg' },
  Update_Approved: { fileName: '/images/svgs/taksering/update-approved.svg' },
  Main_Report_Update_Not_Approved: { fileName: '/images/svgs/taksering/update-not-approved.svg' },
  Main_Report_Loaded: { fileName: '/images/svgs/taksering/main-report-loaded.svg' },
  Main_Report_Approved: { fileName: '/images/svgs/taksering/main-report-approved.svg' },
  Main_Report_Not_Approved: { fileName: '/images/svgs/taksering/main-report-not-approved.svg' },

  Additional_Report: { fileName: '/images/svgs/invoicelog/additional-report-received.svg' },
  After_Evaluation: { fileName: '/images/svgs/invoicelog/afterevaluation-sent.svg' },
  Addon_Price: { fileName: '/images/svgs/taksering/Additional-sales-VS.svg' },
  Estimation_Request: { fileName: '/images/svgs/taksering/additional-support_VS.svg' },
  Estimation_Request_White: { fileName: '/images/svgs/taksering/additional-support_VS-white.svg' },
  Estimation: { fileName: '/images/svgs/taksering/additional-support-added.svg' },
  Estimation_Complete: { fileName: '/images/svgs/taksering/damage-assessment.svg' },
  Workcard: { fileName: '/images/svgs/taksering/work-card.svg' },
  Assesment_History: { fileName: '/images/svgs/invoicelog/assesment-history.svg' },
  Ready_Invoice: { fileName: '/images/svgs/invoicelog/ready-for-invoice.svg' },
  Sent_To_Invoice: { fileName: '/images/svgs/invoice/posted-not-billed.svg' },
  Invoiced: { fileName: '/images/svgs/invoice/Payment-ok.svg' },
  Crediting: { fileName: '/images/svgs/invoicelog/crediting.svg' },
  Credit_Note: { fileName: '/images/svgs/invoicelog/credit-note.svg' },
  Invoice: { fileName: '/images/svgs/invoicelog/invoice.svg' },
  Addon: { fileName: '/images/svgs/invoicelog/additional-sales-new.svg' },
  Total_Price: { fileName: '/images/svgs/invoice/Total_price.svg' },
  Payment_Notif: { fileName: '/images/svgs/invoicelog/payment-notification.svg' },
  ForsiNotActive_White: { fileName: '/images/svgs/FORSI-not-active-white.svg' }
}

export const ClockIcons = {
  Punch_In: { fileName: '/images/icons/Punch-clock-in-Black.png' },
  Punch_Out: { fileName: '/images/icons/Punch-clock-out-Black.png' },
  Punch_Out_Red: { fileName: '/images/icons/Punch-clock-out-Red.png' }
}

export const EvaluationHistoryIcons = {
  Invoice_Add: { fileName: '/images/svgs/taksering/add-to-invoice.svg' },
  Deviation: { fileName: '/images/icons/Internal-Deviation.png' },
  Comment: { fileName: '/images/svgs/comment/comment-new.svg' },
  Order_Data: { fileName: '/images/svgs/ordrer/Car-info-VS.svg' }
}

export const MyPageIcons = {
  My_Messages: { fileName: '/images/svgs/menuicons/Messages-Black.svg' },
  My_Orders: { fileName: '/images/svgs/Orders-black.svg' },
  My_Tasks: { fileName: '/images/svgs/menuicons/Task-Black.svg' }
}

export const MassInvoiceIcons = {
  Reg_No: { fileName: '/images/svgs/invoice/reg-no.svg' },
  Type_Model: { fileName: '/images/svgs/invoice/Type-model.svg' },
  Customer: { fileName: '/images/svgs/invoice/Customer.svg' },
  Handsover: { fileName: '/images/svgs/listheader/Handsover-New.svg' },
  Total_price: { fileName: '/images/svgs/invoice/Total_price.svg' }
}

export const ColorIcons = {
  Color_Name: { fileName: '/images/svgs/color/Color.svg' },
  Color_Code: { fileName: '/images/svgs/color/Color_code.svg' },
  Color_Variant: { fileName: '/images/svgs/color/color-variation.svg' },
  Color_Amount: { fileName: '/images/svgs/color/Color_amount-VS.svg' },
  Color_Ready: { fileName: '/images/svgs/color/Color-ok.svg' }
}

export const ProductionStatus = {
  Step_New: { fileName: '/images/svgs/workscreen/neworder.svg' },
  Step_BodyShopDisassemply: { fileName: '/images/svgs/workscreen/demount.svg' },
  Step_BodyShopRepair: { fileName: '/images/svgs/workscreen/reparation.svg' },
  Step_Preparing: { fileName: '/images/svgs/workscreen/clean.svg' },
  Step_Filler: { fileName: '/images/svgs/workscreen/filler.svg' },
  Step_Archived: { fileName: '/images/svgs/inspection/price.svg' },
  Step_Painting: { fileName: '/images/svgs/workscreen/coating.svg' },
  Step_Finishing: { fileName: '/images/svgs/workscreen/preparing.svg' },
  Step_BodyShopAssembly: { fileName: '/images/svgs/workscreen/mount.svg' },
  Step_BodyShopFinishing: { fileName: '/images/svgs/workscreen/clean.svg' },
  Step_Handover: { fileName: '/images/svgs/workscreen/delivered.svg' },
  Step_Finished: { fileName: '/images/svgs/taksering/main-report-loaded.svg' },
  Step_Completed: { fileName: '/images/svgs/workscreen/Completed-Black.svg' },
  Step_Expected: { fileName: '/images/svgs/workscreen/neworder.svg' }
}

export const AssignmentStepStatus = {
  // 1
  Step_New_Black: { fileName: '/images/svgs/steps/neworder_black.svg' },
  Step_New_Red: { fileName: '/images/svgs/steps/neworder_red.svg' },
  Step_New_White: { fileName: '/images/svgs/steps/neworder_white.svg' },

  // 101
  Step_BodyShopDisassemply_Black: { fileName: '/images/svgs/steps/demount_black.svg' },
  Step_BodyShopDisassemply_White: { fileName: '/images/svgs/steps/demount_white.svg' },
  Step_BodyShopDisassemply_Red: { fileName: '/images/svgs/steps/demount_red.svg' },

  // 102
  Step_BodyShopRepair_Black: { fileName: '/images/svgs/steps/reparation_black.svg' },
  Step_BodyShopRepair_White: { fileName: '/images/svgs/steps/reparation_white.svg' },
  Step_BodyShopRepair_Red: { fileName: '/images/svgs/steps/reparation_red.svg' },

  // 2
  Step_Preparing_Black: { fileName: '/images/svgs/steps/pretreatment_black.svg' },
  Step_Preparing_White: { fileName: '/images/svgs/steps/pretreatment_white.svg' },
  Step_Preparing_Red: { fileName: '/images/svgs/steps/pretreatment_red.svg' },

  // 3
  Step_Filling_Black: { fileName: '/images/svgs/steps/filler_black.svg' },
  Step_Filling_White: { fileName: '/images/svgs/steps/filler_white.svg' },
  Step_Filling_Red: { fileName: '/images/svgs/steps/filler_red.svg' },

  // 4
  Step_Sanding_Black: { fileName: '/images/svgs/steps/sanding_black.svg' },
  Step_Sanding_White: { fileName: '/images/svgs/steps/sanding_white.svg' },
  Step_Sanding_Red: { fileName: '/images/svgs/steps/sanding_red.svg' },

  // 5
  Step_Painting_Black: { fileName: '/images/svgs/steps/coating_black.svg' },
  Step_Painting_White: { fileName: '/images/svgs/steps/coating_white.svg' },
  Step_Painting_Red: { fileName: '/images/svgs/steps/coating_red.svg' },

  // 6
  Step_Finishing_Black: { fileName: '/images/svgs/steps/preparing_black.svg' },
  Step_Finishing_White: { fileName: '/images/svgs/steps/preparing_white.svg' },
  Step_Finishing_Red: { fileName: '/images/svgs/steps/preparing_red.svg' },

  // 103
  Step_BodyShopAssembly_Black: { fileName: '/images/svgs/steps/mount_black.svg' },
  Step_BodyShopAssembly_White: { fileName: '/images/svgs/steps/mount_white.svg' },
  Step_BodyShopAssembly_Red: { fileName: '/images/svgs/steps/mount_red.svg' },

  // 104
  Step_BodyShopFinishing_Black: { fileName: '/images/svgs/steps/clean_black.svg' },
  Step_BodyShopFinishing_White: { fileName: '/images/svgs/steps/clean_white.svg' },
  Step_BodyShopFinishing_Red: { fileName: '/images/svgs/steps/clean_red.svg' },

  // 105
  Step_BodyShopPainting_Black: { fileName: '/images/svgs/steps/coating_black.svg' },
  Step_BodyShopPainting_White: { fileName: '/images/svgs/steps/coating_white.svg' },
  Step_BodyShopPainting_Red: { fileName: '/images/svgs/steps/coating_red.svg' }
}

export const MainMenuIcons = {
  /* Adresses_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Addresses.svg' },
  Adresses_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Addresses.svg' },
  CarRental_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Rentals.svg' },
  CarRental_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Rentals.svg' },
  Chain_Black: { fileName: '/images/svgs/header-icons/Workscreen-black.svg' },
  Chain_White: { fileName: '/images/svgs/header-icons/Workscreen-White.svg' },
  Customers_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Clients.svg' },
  Customers_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Clients.svg' },
  Employees_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Employees.svg' },
  Employees_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Employees.svg' },
  Forsi_Black: { fileName: '/images/icons/menu/Forsi-Black30x30px.png' },
  Forsi_White: { fileName: '/images/icons/menu/Forsi-White30x30px.png' },
  HourReport_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Time-Report.svg' },
  HourReport_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Time-Report.svg' },
  Insurance_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Insurance-Companies.svg' },
  Insurance_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Insurance-Companies.svg' },
  Messages_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Messages.svg' },
  Messages_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Messages.svg' },
  OrderList_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Orders.svg' },
  OrderList_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Orders.svg' },
  Partners_Black: { fileName: '/images/icons/menu/Partners-Black.png' },
  Partners_White: { fileName: '/images/icons/menu/Partners-White.png' },
  PriceLists_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Price-Lists.svg' },
  PriceLists_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Price-Lists.svg' },
  PunchClock_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Punch-Clock.svg' },
  PunchClock_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Punch-Clock.svg' },
  QualityCheck_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Quality-Assurance.svg' },
  QualityCheck_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Quality-Assurance.svg' },
  Settings_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Settings.svg' },
  Settings_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Settings.svg' },
  // Subcontractors_Black: { fileName: '/images/icons/menu/reseller.svg' }
  Shops_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Clients.svg' },
  Shops_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Clients.svg' },
  Statistics_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Statistics.svg' },
  Statistics_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Statistics.svg' },
  Tasks_Black: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Tasks.svg' },
  Tasks_White: { fileName: '/images/svgs/Navigation/Icon-Primary-Navigation-Tasks.svg' },
  WorkScreen_Black: { fileName: '/images/svgs/header-icons/Workscreen-black.svg' },
  WorkScreen_White: { fileName: '/images/svgs/header-icons/Workscreen-White.svg' } */

  Adresses_Black: { fileName: '/images/svgs/menuicons/Other-adress-black.svg' },
  Adresses_White: { fileName: '/images/svgs/header-icons/Other-adress-white.svg' },
  Chain_Black: { fileName: '/images/svgs/menuicons/Workscreen-black.svg' }, // was images/icons/orderlist301.png but there is no such file??
  Chain_White: { fileName: '/images/svgs/header-icons/Workscreen-white.svg' },
  Shops_Black: { fileName: '/images/svgs/menuicons/Customers-Black.svg' },
  Shops_White: { fileName: '/images/svgs/header-icons/Customers-White.svg' },
  Partners_Black: { fileName: '/images/svgs/menuicons/Partners-Black.svg' },
  Partners_White: { fileName: '/images/svgs/header-icons/Partners-white.svg' },
  OrderList_Black: { fileName: '/images/svgs/menuicons/Orders-black.svg' },
  OrderList_White: { fileName: '/images/svgs/header-icons/Orders-white.svg' },
  WorkScreen_Black: { fileName: '/images/svgs/menuicons/Workscreen-black.svg' },
  WorkScreen_White: { fileName: '/images/svgs/header-icons/Workscreen-white.svg' },
  Insurance_Black: { fileName: '/images/svgs/ordrer/Insurance-black.svg' },
  Insurance_White: { fileName: '/images/svgs/ordrer/Insurance-white.svg' },
  Forsi_Black: { fileName: '/images/svgs/menuicons/Forsi-Black.svg' },
  Forsi_White: { fileName: '/images/svgs/header-icons/Forsi-White.svg' },
  PriceLists_Black: { fileName: '/images/svgs/menuicons/Prices-Black.svg' },
  PriceLists_White: { fileName: '/images/svgs/header-icons/Prices-White.svg' },
  QualityCheck_Black: { fileName: '/images/svgs/menuicons/qualitycontrol-black.svg' },
  QualityCheck_White: { fileName: '/images/svgs/header-icons/qualitycontrol-white.svg' },
  Customers_Black: { fileName: '/images/svgs/menuicons/Customers-Black.svg' },
  Customers_White: { fileName: '/images/svgs/header-icons/Customers-White.svg' },
  Employees_Black: { fileName: '/images/svgs/menuicons/Employees-black.svg' },
  Employees_White: { fileName: '/images/svgs/header-icons/Employees-white.svg' },
  PunchClock_Black: { fileName: '/images/svgs/menuicons/Punch-clock-black.svg' },
  PunchClock_White: { fileName: '/images/svgs/header-icons/Punch-clock-white.svg' },
  HourReport_Black: { fileName: '/images/svgs/menuicons/Timer-black.svg' },
  HourReport_White: { fileName: '/images/svgs/header-icons/Timer-white.svg' },
  CarRental_Black: { fileName: '/images/svgs/menuicons/lend.svg' },
  CarRental_White: { fileName: '/images/svgs/menuicons/lend-White.svg' },
  Statistics_Black: { fileName: '/images/svgs/menuicons/Statistics-black.svg' },
  Statistics_White: { fileName: '/images/svgs/header-icons/Statistics-white.svg' },
  Tasks_Black: { fileName: '/images/svgs/menuicons/Task-Black.svg' },
  Tasks_White: { fileName: '/images/svgs/menuicons/Task-White.svg' },
  Messages_Black: { fileName: '/images/svgs/menuicons/Messages-Black.svg' },
  Messages_White: { fileName: '/images/svgs/header-icons/Messages-white.svg' },
  Settings_Black: { fileName: '/images/svgs/menuicons/Settings-black.svg' },
  Settings_White: { fileName: '/images/svgs/header-icons/Settings-white.svg' },
  Subcontractors_Black: { fileName: '/images/icons/menu/reseller.svg' },
  Subcontractors_White: { fileName: '/images/svgs/header-icons/reseller-white.svg' },
  SpareParts_Black: { fileName: '/images/svgs/menuicons/spare-parts-black.svg' },
  SpareParts_White: { fileName: '/images/svgs/header-icons/spare-parts-white.svg' },
  CollaboratingPartners_Black: { fileName: '/images/svgs/menuicons/New-order-red-referred-black.svg' },
  CollaboratingPartners_White: { fileName: '/images/svgs/header-icons/New-order-referred-white.svg' },
  PasswordChange_White: { fileName: '/images/svgs/menuicons/Change_password-white.svg' }
}

export const ModalIcons = {
  WorkHours_Log: { fileName: '/images/svgs/log-white.svg' },
  Stop_Order: { fileName: '/images/icons/Stop-White.png' },
  Estimation: { fileName: '/images/icons/additional-support-white_VS.svg' },
  Refer_Order: { fileName: '/images/icons/Referred_white30.png' },
  Quality_Check: { fileName: '/images/icons/menu/qualitycontrol-White.png' },
  Plus: { fileName: '/images/icons/circle_plus22.png' },
  Camera: { fileName: '/images/icons/Camera_white.png' },
  Note: { fileName: '/images/icons/note-white.png' },
  Shared_Screen: { fileName: '/images/icons/shared-screen-white.svg' },
  Forward: { fileName: '/images/icons/Forward-White.png' },
  Backward: { fileName: '/images/icons/Backward-White.png' },
  Mass_Invoice: { fileName: '/images/svgs/listheader/mass-invoiceing-white.svg' },
  Total_Wreck: { fileName: '/images/icons/total-wreck-white.svg' },
  Employees_White: { fileName: '/images/icons/menu/Employees-white-30x30.png' },
  Link: { fileName: '/images/icons/Link-White.png' },
  Help: { fileName: '/images/icons/Help-White.png' },
  Payment_Notif: { fileName: '/images/icons/payment-notification_white.svg' },
  Repport_Data: { fileName: '/images/svgs/modalicons/Repportdata-white.svg' },
  CarRental: { fileName: '/images/svgs/menuicons/lend-White.svg' }
}

export const DashboardIcons = {
  External_Link_Blue: { fileName: '/images/icons/Click-pil-16-Blue.png' },
  Dashboard_Blue: { fileName: '/images/icons/Dashboard-30-Blue.png' },
  Report_Data_Blue: { fileName: '/images/icons/Repportdata30-Blue.png' },
  Arrow_Black: { fileName: '/images/svgs/statistics/Click-pil-black.svg' },
  Arrow_White: { fileName: '/images/svgs/statistics/Click-pil-white.svg' },
  Dashboard_Black: { fileName: '/images/svgs/statistics/Dashboard-black.svg' },
  Dashboard_White: { fileName: '/images/svgs/statistics/Dashboard-white.svg' },
  Report_Data_Black: { fileName: '/images/svgs/statistics/Repportdata-black.svg' },
  Report_Data_White: { fileName: '/images/svgs/statistics/Repportdata-white.svg' }
}

export const MarkImageIcons = {
  Rotate: { fileName: '/images/svgs/actions/Rotate-picture.svg' },
  Add_PC: { fileName: '/images/svgs/actions/Add-pc.svg' },
  Add_Phone: { fileName: '/images/svgs/actions/Ad-selection.svg' },
  Delete: { fileName: '/images/svgs/actions/Delete-selection.svg' },
  Approve: { fileName: '/images/svgs/actions/Aprove-selection.svg' },
  Close: { fileName: '/images/svgs/actions/close-side.svg' }
}

export const ReferenceIcons = {
  Referred: { fileName: '/images/icons/referred-order-white-red.svg' },
  Referred_Approved: { fileName: 'images/svgs/referal/referred-order-green.svg' },
  Referred_NotApproved: { fileName: '/images/icons/referred-order-white.svg' },
  Customer: { fileName: '/images/svgs/invoice/Customer.svg' },
  Comment: { fileName: '/images/svgs/comment/comment-new.svg' },
  Referred_From: { fileName: 'images/svgs/referal/referred-order.svg' },
  Extent: { fileName: 'images/svgs/inspection/assessment.svg' },
  Info: { fileName: 'images/svgs/referal/Car-info-VS.svg' }
}

export const SparePartModuleIcons = {
  OK: { fileName: '/images/svgs/status/OK.svg' },
  Warning: { fileName: '/images/svgs/status/Warning.svg' },
  Attention: { fileName: '/images/svgs/status/Attention.svg' },
  Coating: { fileName: '/images/svgs/steps/Coating.svg' },
  Pickup: { fileName: '/images/svgs/ordrer/Pickup.svg' },
  Defective: { fileName: '/images/svgs/status/Defective.svg' },
  Incorrect: { fileName: '/images/svgs/status/Incorrect.svg' },
  Back: { fileName: '/images/elements/buttons/Back.svg' },
  Urgent: { fileName: '/images/svgs/ordrer/Urgent.svg' }
}

export const EmbeddedBookingIcons = {
  Camera: { fileName: '/images/svgs/embeddedbooking/kamera.svg' },
  Arrow: { fileName: '/images/svgs/embeddedbooking/pil-steps.svg' },
  Photo_Guide_1: { fileName: '/images/svgs/embeddedbooking/empty.svg' },
  Photo_Guide_2: { fileName: '/images/svgs/embeddedbooking/distance.svg' },
  Photo_Guide_3: { fileName: '/images/svgs/embeddedbooking/entirecar.svg' },
  Photo_Guide_4: { fileName: '/images/svgs/embeddedbooking/nearby.svg' },
  Photo_Guide_5: { fileName: '/images/svgs/embeddedbooking/closeup-straight.svg' },
  Photo_Guide_6: { fileName: '/images/svgs/embeddedbooking/closeup-otherangles.svg' },
  Upload_Image: { fileName: '/images/svgs/embeddedbooking/upload.svg' },
  Left_Arrow: { fileName: '/images/svgs/embeddedbooking/leftarrow.svg' },
  Right_Arrow: { fileName: '/images/svgs/embeddedbooking/rightarrow.svg' },
  Edit_Pencil: { fileName: '/images/svgs/embeddedbooking/editpencil.svg' }
}

export const CarRentalIcons = {
  OK: { fileName: '/images/svgs/status/OK.svg' },
  Warning: { fileName: '/images/svgs/status/Warning.svg' }
}

export const CapacityManagementIcons = {
  Loose_Part: { fileName: '/images/svgs/transport/loose part-black.svg' },
  Job_Done: { fileName: '/images/svgs/capacitymanagement/check-green.svg' },
  Issue: { fileName: '/images/svgs/capacitymanagement/warning-red.svg' },
  CarRental_Black: { fileName: '/images/svgs/capacitymanagement/lend.svg' },
  OrderList_Black: { fileName: '/images/svgs/capacitymanagement/Orders-black.svg' },
  Chain_Black: { fileName: '/images/svgs/capacitymanagement/Workscreen-black.svg' },
  Indent: { fileName: '/images/svgs/Indent.svg' },
  Assign: { fileName: '/images/svgs/capacitymanagement/Assign.svg' },
  Filter: { fileName: '/images/svgs/capacitymanagement/Filter.svg' },
  info: { fileName: '/images/svgs/capacitymanagement/info.svg' },
  Calendar: { fileName: '/images/svgs/capacitymanagement/calendar_24.svg' },
  List_View: { fileName: '/images/svgs/capacitymanagement/list_view.svg' },

  Completed: { fileName: '/images/svgs/capacitymanagement/Completed.svg' },
  Warning_assign: { fileName: '/images/svgs/capacitymanagement/Warning_assign.svg' },
  Warning_delayed: { fileName: '/images/svgs/capacitymanagement/Warning_delayed.svg' },
  warning_painter: { fileName: '/images/svgs/capacitymanagement/warning_painter.svg' },
  Warning_spare_part: { fileName: '/images/svgs/capacitymanagement/Warning_spare_part.svg' },
  Warning_Order_stop: { fileName: '/images/svgs/capacitymanagement/Warning_order_stop.svg' },
  Warning_attention_white: { fileName: '/images/svgs/capacitymanagement/Warning_attention_white.svg' },

  Arrow_Down: { fileName: '/images/svgs/capacitymanagement/Arrow_Down.svg' },
  Arrow_Right: { fileName: '/images/svgs/capacitymanagement/Arrow_Right.svg' },
  Group_Arrow_Down: { fileName: '/images/svgs/capacitymanagement/Group-Arrow-Down.svg' },
  Group_Arrow_Right: { fileName: '/images/svgs/capacitymanagement/Group-Arrow-Right.svg' }
}

export const TimeLineIcons = {
  Ok_Green: { fileName: '/images/svgs/capacitymanagement/check-green.svg' },
  Exclamation_Red: { fileName: '/images/svgs/capacitymanagement/warning-red.svg' }
}

export const CarOwnerPortalIcons = {
  Message: { fileName: '/images/svgs/carownerportal/message.svg' },
  Active: { fileName: '/images/svgs/status/OK.svg' },
  NotSent: { fileName: '/images/svgs/status/Attention.svg' },
  Awaiting: { fileName: '/images/svgs/carownerportal/awaiting.svg' },
  Declined: { fileName: '/images/svgs/carownerportal/declined.svg' }
}



// WEBPACK FOOTER //
// ./src/app/shared/elements/icons.js